<template>
  <div class="container">
    <div class="content">
      <h2>Welcome to the RiskyPaws Onboarding Journey! Your Path to Purr-sonal Wealth Starts Now!</h2>
      <p>At RiskyPaws, we believe in more than just nine lives; we're talking about a lifetime of financial well-being. Let's chat about why understanding your current financial standing is the cat's meow.</p>
      <p>You see, we're like your own personalized financial scratching post—tailored to suit your unique needs and challenges. By sharing a bit about where you're at financially, you're helping us:</p>
      <ul>
        <li>🎯 <b>Curate Content:</b> We want to serve you the most relevant tips, tools, and tricks. No sense in offering you advanced investment strategies if you're just learning how to budget, right?</li><br>
        <li>🔧 <b>Customize Tools:</b> From tax calculators for beginners to complex investment trackers for the financially savvy, we've got something for every stage of your financial life.</li><br>
        <li>📈 <b>Chart Your Growth:</b> Knowing your starting point is crucial for tracking progress. Whether it's saving for your first car or planning for retirement, we'll help you set achievable goals.</li><br>
        <li>👔 <b>Understand Your Worth:</b> We're not just talking about your salary; think total compensation, including benefits like healthcare and retirement plans. We want you to be fully equipped to negotiate your way to your true value.</li><br>
        <li>🐾 <b>Introduce you to your Financial Cat Companion:</b> Just as cats have diverse personalities, so do you. Through this onboarding journey, we'll match you with a feline financial guru who embodies your investment style and risk tolerance. This unique companion will guide you through the complexities of finance, offering tailored advice and insights. Are you a cautious observer or a daring explorer? Let's find out together!</li><br>
      </ul>
      <p>Ready to embark on this journey? Let's discover which cat companion aligns with your financial personality, guiding you through the world of personal finance with wisdom, courage, and a touch of feline intuition.</p>
    </div>
  </div><br><br><br><br><br><br>
</template>
 
<script>
import { computed } from 'vue';
import { onboardingStore } from '@/components/stores/onboardingStore';

export default {
  setup() {
    const store = onboardingStore();

    // Use a computed property to link the checkbox with the store's data
    const privacyAgreement = computed({
      get: () => store.formData.privacy === 'yes', // Returns true if the value is 'YES'
      set: (value) => {
        // Sets the value to 'YES' if checked, or an empty string if not
        store.updateFormData({ privacy: value ? 'yes' : '' });
      },
    });

    return {
      privacyAgreement,
      // include formData in return if you need to use it in the template
      formData: store.formData
    };
  },
};
</script>

 
 
 <style scoped>
.container {
 background-color: #4A148C; 
 color: black;
 padding: 20px;
 border-radius: 20px;
 display: flex;
  flex-direction: column;
  justify-content: center;
  min-width: 300px;
  max-width: 800px; /* Set a maximum width */
  align-items: center; /* Centered alignment */
  margin: auto; /* Center the container on the page */
  margin-top: 0; /* Adjusted as per your requirement */
}

.content {
 background-color: white;
 padding: 20px;
 border-radius: 10px;
 color: black;
}
 </style>
 